import Cookies from 'universal-cookie';
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

export const TwitterLandingRedirect = () => {
  const cookies = new Cookies();
  cookies.set('last_landing_rule', '/twitter', { domain: cookieDomain });
  cookies.set('landing_page', '/twitter', { domain: cookieDomain });
  window.location = '/';
  return null;
};
